"use strict";
// Google Consent Mode
// https://developers.google.com/tag-platform/devguides/consent
Object.defineProperty(exports, "__esModule", { value: true });
class ConsentMode {
    // None of theses are used because of how global site tag functions
    // It seems to only work when it pushes an argument to dataLayer
    static addToDatalayer(...args) {
        // args = command: string, targetId: string, config?: AdvancedConsent | boolean
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(args);
    }
}
ConsentMode.update = (updateTypes) => {
    ConsentMode.addToDatalayer("consent", "update", updateTypes);
};
exports.default = ConsentMode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc2VudE1vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXh0ZW50aW9ucy9jb25zZW50TW9kZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHNCQUFzQjtBQUN0QiwrREFBK0Q7O0FBa0IvRCxNQUFNLFdBQVc7SUFDYixtRUFBbUU7SUFDbkUsZ0VBQWdFO0lBQ3hELE1BQU0sQ0FBQyxjQUFjLENBQUMsR0FBRyxJQUFJO1FBQ2pDLCtFQUErRTtRQUMvRSxNQUFNLENBQUMsU0FBUyxHQUFHLE1BQU0sQ0FBQyxTQUFTLElBQUksRUFBRSxDQUFDO1FBQzFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2hDLENBQUM7O0FBRWEsa0JBQU0sR0FBRyxDQUFDLFdBQXlCLEVBQUUsRUFBRTtJQUNqRCxXQUFXLENBQUMsY0FBYyxDQUFDLFNBQVMsRUFBRSxRQUFRLEVBQUUsV0FBVyxDQUFDLENBQUM7QUFDakUsQ0FBQyxDQUFDO0FBR04sa0JBQWUsV0FBVyxDQUFDIn0=